import { Navigate, Outlet } from 'react-router-dom';
import type { Role } from '@/api/types';
import { landingRoute, useAuth } from './AuthContext';

export function RequireRole({ allow }: { allow: Role[] }) {
  const { roles } = useAuth();
  const permitted = roles.some((role) => allow.includes(role));

  if (!permitted) {
    return <Navigate to={landingRoute(roles)} replace />;
  }
  return <Outlet />;
}
